module.exports = __webpack_public_path__ + "static/images/sku-empty-menu.66aecceef96f15f89c56b3dc35444ca9.svg";